import { Form, Button, Input, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import moment from "moment";

import email1 from "../../assets/images/email-setup/email-1.svg";
import email2 from "../../assets/images/email-setup/email-2.svg";
import email3 from "../../assets/images/email-setup/email-3.svg";
import email4 from "../../assets/images/email-setup/email-4.svg";
import gmail from "../../assets/images/auth/gmail.svg";
import outlook from "../../assets/images/email-setup/outlook.png";
import smtp from "../../assets/images/email-setup/SMTP.png";
import AccountManagement from "./AccountManagement";
import SMTPEmail from "./SMTPEmail";
import { useAuth } from "./hooks/useAuth";
import { EmailContext } from "../../context/EmailContext";
import Loader from "../loader";
import SubscriptionModal from "../web2lead/SubscriptionModal";
import { getSubscriptionUserInfo } from "../../utils/utils";
import notConnected from "../../assets/svg/icons/nothing-found-email.svg";
import connect from "../../assets/svg/icons/connect-email.svg";

const items = [
  {
    icon: email1,
    text: "Monitor email opens and click activity",
  },
  {
    icon: email2,
    text: "Access ready-to-use templates",
  },
  {
    icon: email3,
    text: "Schedule emails for later delivery",
  },
  {
    icon: email4,
    text: "Leverage Magic AI to craft personalized emails",
  },
];

const SetupEmail = () => {
  const [form] = Form.useForm();
  const [subModal, setSubModal] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [email, setEmail] = useState();
  const { handleConnectEmail, handleRemove, error, setError } = useAuth();
  const subscription = getSubscriptionUserInfo();
  const currentDate = moment();
  const validToDate = moment(subscription?.validTo);
  const isExpired = validToDate.isBefore(currentDate);
  const { emailConfiguration, isEmailConfigured, loading } =
    useContext(EmailContext);

  const onSubmit = (value) => {
    setError();
    if (!subscription?.id || isExpired) {
      setSubModal(true);
    } else {
      if (value.emailDomain === "Others") {
        setOpen(true);
        setEmail(value.email);
      } else {
        handleConnectEmail(value);
      }
    }
  };

  const inputEmail = Form.useWatch("email", form);

  useEffect(() => {
    setError();
  }, [inputEmail, setError]);

  return (
    <section className="p-20 h-100">
      <SubscriptionModal
        isOpen={subModal}
        handleCancel={() => setSubModal(false)}
      />
      {loading ? (
        <Loader />
      ) : (
        <>
          {isEmailConfigured ? (
            <AccountManagement
              emailConfiguration={emailConfiguration}
              onRemove={handleRemove}
            />
          ) : (
            <>
              <SMTPEmail
                isOpen={isOpen}
                email={email}
                handleCancel={() => {
                  setOpen(false);
                  setEmail();
                }}
              />

              <div className="tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center">
                <img src={notConnected} alt="" />
                <h1 className="tw-text-2xl tw-font-bold tw-text-theme tw-mt-6">
                  Streamline Your Email Communication!
                </h1>
                <p className="tw-text-lg tw-text-sub-text">
                  Sync your email accounts and associate sales emails with{" "}
                  <span className="tw-text-lg tw-font-bold">
                    deals, leads, or contacts.
                  </span>
                </p>
                <div>
                  <div className="tw-flex tw-items-start tw-gap-10 mt30">
                    {items.map((d, i) => (
                      <div
                        key={i}
                        className="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-max-w-[200px]"
                      >
                        <div className="tw-size-[50px] tw-bg-[#EBEBEB] tw-rounded-[10px] tw-flex tw-items-center tw-justify-center">
                          <img src={d.icon} alt="" width={15} height={15} />
                        </div>
                        <p className="tw-text-sm tw-font-normal tw-text-center tw-text-text-primary">
                          {d.text}
                        </p>
                      </div>
                    ))}
                  </div>
                  <Form
                    form={form}
                    layout="inline"
                    className="tw-mt-10 d-flex tw-pt-8"
                    onFinish={onSubmit}
                  >
                    <Form.Item
                      name="emailDomain"
                      rules={[
                        { required: true, message: "Please select a domain" },
                      ]}
                    >
                      <div className="tw-flex tw-items-center tw-gap-3 tw-min-h-[44px]">
                        <span className="tw-text-sm tw-text-text-primary tw-font-semibold tw-whitespace-nowrap">
                          Email address<span className="text-error">*</span>
                        </span>
                        <Select
                          placeholder="Select Domain"
                          className="tw-h-[44px] !tw-w-[150px]"
                          onChange={(val) => {
                            form.setFieldsValue({ emailDomain: val });
                          }}
                        >
                          <Select.Option value="Gmail">
                            <div className="heading13px d-flex align-items-center">
                              <img
                                src={gmail}
                                alt=""
                                width="15"
                                height="15"
                                className="mr-2"
                              />
                              Gmail
                            </div>
                          </Select.Option>
                          <Select.Option value="Outlook">
                            <div className="heading13px d-flex align-items-center">
                              <img
                                src={outlook}
                                alt=""
                                width="15"
                                height="15"
                                className="mr-2"
                              />
                              Outlook
                            </div>
                          </Select.Option>
                          <Select.Option value="Others">
                            <div className="heading13px d-flex align-items-center">
                              <img
                                src={smtp}
                                alt=""
                                width="15"
                                height="15"
                                className="mr-2"
                              />
                              Others
                            </div>
                          </Select.Option>
                        </Select>
                      </div>
                    </Form.Item>

                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          type: "email",
                          message: "Please enter a valid email",
                        },
                      ]}
                    >
                      <Input
                        className="common-input !tw-h-[44px]"
                        style={{ width: 330 }}
                        placeholder="Donald@abctechnologies.com"
                      />
                    </Form.Item>

                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="theme-btn tw-h-[44px]"
                      >
                        <img src={connect} alt="" />
                        Connect email account
                      </Button>
                    </Form.Item>
                  </Form>
                  {error && <p className="text-error mt10 pb-2"> {error}</p>}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </section>
  );
};

export default SetupEmail;
